/* eslint-disable flowtype/no-types-missing-file-annotation */
export const INPUT_TEXT_CHANGE = 'INPUT_TEXT_CHANGE';
export const SELECT_TYPE_CHANGE = 'SELECT_TYPE_CHANGE';
export const SELECT_NUM_CHANGE = 'SELECT_NUM_CHANGE';
export const SET_SHOW_HISTORY = 'SET_SHOW_HISTORY';

export const FETCH_SEARCH_RESULT = 'global-search-bar/FETCH_SEARCH_RESULT';
export const FETCH_SEARCH_HISTORY = 'global-search-bar/FETCH_SEARCH_HISTORY';
export const FETCH_SEARCH_CATEGORY_HISTORY =
  'global-search-bar/FETCH_SEARCH_CATEGORY_HISTORY';
export const SEARCHTYPE = [
  'Registration',
  'Driver',
  'Lease ID',
  'Vehicle Type'
];
export const SEARCH_TYPE_MAP = {
  Registration: 'registration',
  Driver: 'driver',
  'Lease ID': 'id',
  'Vehicle Type': 'type'
};

// Global search - SAVE Search TO history
export const SAVE_SEARCH_TO_HISTORY =
  'global-search-bar/SAVE_SEARCH_TO_HISTORY';

export type Action =
  | { type: FETCH_SEARCH_HISTORY }
  | { type: SAVE_SEARCH_TO_HISTORY };



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/store/TYPES.js